const ArrowUpRight = ({ size=20, color="#000000", ...props }) => (
    <svg
        height={size}
        width={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M7 7h10v10"/>
        <path d="M7 17 17 7"/>
    </svg>
);

export default ArrowUpRight;
